export default function getInitialState() {
  return {
    isWhiteboardActive: false,
    whiteboardOwnerParticipantId: null,
    whiteboardId: null,
    token: null,
    isWhiteboardLargeSessionModalVisible: false
  };
}
